"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _DropAreaBase = _interopRequireDefault(require("../DropAreaBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      border: "1px solid ".concat(theme.palette.divider),
      borderRadius: theme.shape.borderRadius,
      '&:hover, &$dragOver': {
        borderColor: theme.palette.primary.main,
        '&$disabled': {
          borderColor: theme.palette.divider
        }
      },
      transition: theme.transitions.create('border-color'),
      '& *': {
        pointerEvents: 'none'
      }
    },
    clickable: {
      cursor: 'pointer',
      '&$disabled': {
        cursor: 'default'
      }
    },
    disabled: {},
    dragOver: {
      '&$disabled': {
        cursor: 'no-drop !important'
      }
    }
  };
};

var FileSelectArea = _react.default.forwardRef(function FileSelectArea(props, ref) {
  var _classNames;

  var children = props.children,
      className = props.className,
      classes = props.classes,
      onSelectFiles = props.onSelectFiles,
      other = _objectWithoutProperties(props, ["children", "className", "classes", "onSelectFiles"]);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dragOver = _React$useState2[0],
      setDragOver = _React$useState2[1];

  var handleDragOver = function handleDragOver() {
    setDragOver(true);
  };

  var handleDragLeave = function handleDragLeave() {
    setDragOver(false);
  };

  var handleSelectFiles = function handleSelectFiles(files) {
    setDragOver(false);
    onSelectFiles(files);
  };

  return _react.default.createElement(_DropAreaBase.default, _extends({}, other, {
    className: (0, _classnames.default)(classes.root, className, (_classNames = {}, _defineProperty(_classNames, classes.dragOver, dragOver), _defineProperty(_classNames, classes.clickable, props.clickable), _defineProperty(_classNames, classes.disabled, props.disabled), _classNames)),
    onAcceptedDragEnter: handleDragOver,
    onDragLeave: handleDragLeave,
    onSelectFiles: handleSelectFiles,
    ref: ref
  }), children);
});

FileSelectArea.propTypes = {
  /**
   * Used to render content in the drop area.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the drop area can be clicked to open a file selection dialog.
   */
  clickable: _propTypes.default.bool,

  /**
   * Callback fired when the user selects or drops one or more accepted files.
   */
  onSelectFiles: _propTypes.default.func.isRequired
};
FileSelectArea.defaultProps = {
  clickable: true
};

var _default = (0, _styles.withStyles)(styles)(FileSelectArea);

exports.default = _default;